<template>
  <v-app>
    <v-app-bar app>
      <v-btn icon @click.stop="navigacio = !navigacio"><v-icon>fa-bars</v-icon></v-btn>
      <v-toolbar-title class="headline text-uppercase">
        <span>Eredményrögzítő</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-switch v-model="$vuetify.theme.dark" label="Sötét mód"></v-switch>
      <router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'home'}"><v-btn rounded color="primary">Kezdőlap<v-icon>fa-home</v-icon></v-btn></router-link>
      <router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'bejelentkezes'}"><v-btn rounded color="green">Bejelentkezés<v-icon>fa-sign-in-alt</v-icon></v-btn></router-link>
      <router-link v-if="$store.state.bejelentkezve" :to="{ name: 'profil' }"><v-btn rounded color="pink">
        Profil
        <v-icon
          right
          dark
        >
          fa-user-edit
        </v-icon>
      </v-btn></router-link>
      <router-link v-if="$store.state.bejelentkezve" :to="{ name: 'csoportok' }"><v-btn rounded color="primary">
        Csoportok
      <v-icon
        right
        dark
      >
        fa-users
      </v-icon></v-btn></router-link>
      <router-link  v-if="$store.state.admin" :to="{name: 'admin'}">
        <v-btn rounded color="yellow">
          admin
          <v-icon
            right
            dark
          >
            fa-users-cog
          </v-icon>
        </v-btn></router-link>
      <router-link  v-if="$store.state.admin" :to="{name: 'sablonok'}">
        <v-btn rounded color="orange">
          Sablonok
          <v-icon
            right
            dark
          >
            fa-copy
          </v-icon>
        </v-btn></router-link>
      <v-btn rounded color="red" @click="kijelentkezes()" v-if="$store.state.bejelentkezve">
        Kijelentkezés
        <v-icon
          right
          dark
        >
          fa-sign-out-alt
        </v-icon>
      </v-btn>-->
    </v-app-bar>
    <v-navigation-drawer
      v-model="navigacio"
      absolute
      temporary

    >
      <router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'home'}">
        <v-list-item>
          <v-list-item-icon><v-icon>fa-home</v-icon></v-list-item-icon>
          <v-list-item-content>Kezdőlap</v-list-item-content>
        </v-list-item>
      </router-link>
      <router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'bejelentkezes'}">
        <v-list-item>
          <v-list-item-icon><v-icon>fa-sign-in-alt</v-icon></v-list-item-icon>
          <v-list-item-content>Bejelentkezés</v-list-item-content>
        </v-list-item>
      </router-link>
      <router-link v-if="$store.state.bejelentkezve" :to="{ name: 'profil' }">
        <v-list-item>
          <v-list-item-icon><v-icon>fa-user-edit</v-icon></v-list-item-icon>
          <v-list-item-content>Profil</v-list-item-content>
        </v-list-item>
      </router-link>
      <router-link v-if="$store.state.bejelentkezve" :to="{ name: 'csoportok' }">
        <v-list-item>
          <v-list-item-icon><v-icon>fa-users</v-icon></v-list-item-icon>
          <v-list-item-content>Csoportok</v-list-item-content>
        </v-list-item>
      </router-link>
      <router-link  v-if="$store.state.admin" :to="{name: 'admin'}">
        <v-list-item>
          <v-list-item-icon><v-icon>fa-users-cog</v-icon></v-list-item-icon>
          <v-list-item-content>Admin</v-list-item-content>
        </v-list-item>
      </router-link>
      <router-link  v-if="$store.state.admin" :to="{name: 'sablonok'}">
        <v-list-item>
          <v-list-item-icon><v-icon>fa-copy</v-icon></v-list-item-icon>
          <v-list-item-content>Sablonok</v-list-item-content>
        </v-list-item>
      </router-link>
      <v-list-item>
        <v-list-item-icon><v-icon>fa-moon</v-icon></v-list-item-icon>
        <v-list-item-content><v-switch v-model="$vuetify.theme.dark" label="Sötét mód"></v-switch></v-list-item-content>
      </v-list-item>
      <v-btn rounded color="red" block @click="kijelentkezes()" v-if="$store.state.bejelentkezve">
        Kijelentkezés
        <v-icon
          right
          dark
        >
          fa-sign-out-alt
        </v-icon>
      </v-btn>
    </v-navigation-drawer>
    <v-content>
            <router-view class="view"></router-view>
    </v-content>
  </v-app>
</template>

<script>
     import router from "./router"
export default {
  name: 'App',
  components: {
  },
  data: () => ({
    navigacio: false
  }),
  methods: {
    kijelentkezes: function(){
      this.axios.get(this.$store.state.backendeleres+"kijelentkezes").then((response) => {
      this.$store.commit('bejelentkezve', response.data.bejelentkezve)
      if(!response.data.bejelentkezve){
        router.push('/bejelentkezes');
        this.$store.commit('admin',false)
      }
      })
    }
  },
  mounted (){
    this.axios.get(this.$store.state.backendeleres+"hitelesites/bejelentkezve")
    .then(response => {
      this.$store.dispatch('bejelentkezesallasvaltas', response.data.bejelentkezve)
    })
    this.axios.get(this.$store.state.backendeleres+"hitelesites/admin").then((response) =>{
      this.$store.commit('admin',response.data.admin);
    })
  }
}
</script>
